module.exports = "<footer class=\"col-sm-12\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n      <p>\r\n        Yara - Portais Financeiros\r\n      </p>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <p class=\"text-right\">\r\n        by PerformaIT\r\n      </p>\r\n    </div>\r\n  </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/component/footer.component.html
// module id = ./src/app/footer/component/footer.component.html
// module chunks = main